<template>
<div class='treine-banner'>
    <router-link @click="gaBannerEvent(banner.title)" v-if="banner.link.startsWith('/')" :to="banner.link">
        <img :src="banner.thumbnail_mobile" :class="`banner__mobile ${area}-${banner.slug}-${country}`" :alt="`Acessar a página do ${banner.title}`">
        <img :src="banner.thumbnail_desktop" :class="`banner__desktop ${area}-${banner.slug}-${country}`" :alt="`Acessar a página do ${banner.title}`">
    </router-link>
    <a v-else @click="gaBannerEvent(banner.title)" :href="banner.link" target="_blank">
        <img :src="banner.thumbnail_mobile" :class="`banner__mobile ${area}-${banner.slug}-${country}`" :alt="`Acessar a página do ${banner.title}`">
        <img :src="banner.thumbnail_desktop" :class="`banner__desktop ${area}-${banner.slug}-${country}`" :alt="`Acessar a página do ${banner.title}`">
    </a>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data () {
        let { host } = window.location;
        let host_parts = host.split('.');
        let country = (host.indexOf('smartfit') > -1 ? host_parts[host_parts.length - 1] : 'bioritmo');

        return {
            country,
        }
    },
    props: ['banner', 'area'],
    computed: {
        ...mapGetters([
            'theme',
        ])
    },
    methods: {
        gaBannerEvent(title) {
            if(this.theme === 'smartfit') {
                this.$gtm.trackEvent({
                    event: 'gaEvent',
                    eventCategory: `treine-em-casa-${this.theme}`,
                    eventAction: title,
                    eventLabel: '',
                });
            }
        },
    }
}
</script>


<style lang="scss" scoped>
    .banner {
        &__mobile {
            @media screen and (min-width: 769px){
                display: none;
            }
        }

        &__desktop {
            display: none;

            @media screen and (min-width: 769px){
                display: block;
            }
        }
    }

    [class*="footer-fitdance-3"]:not([class*="footer-fitdance-3-mx"]), [class*="footer-lesmills-2"]:not([class*="footer-lesmills-2-mx"]) {
        display: none !important;
    }
</style>
